export default function selectPermissions(profile) {
	return profile?.permissions || {};
}
